import React from 'react'
import withView from '../docAutomation/withView';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel'
import FormRichText from '../../../library/form/components/FormRichText';
import FormSH from '../../../library/form/components/FormSH';
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle';
import FormWrapper from '../../../library/form/components/FormWrapper'
import FormHHMMInput from '../../../library/form/components/FormHHMMInput';

const DocLogEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '500px' }}
            contentStyle={{ height: '308px' }}
            formTitle={<FormTitle formObject={formObject} value='Task Header' />}
            formObject={formObject} >
            <div className="">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "logTime" }} value="Log Time" />
                </span>
                <FormROValue className="uiVal" formObject={formObject} rowKey="" action={{ paramName: "logTime" }} />

                <span className="uiLblInLine">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "loggedBy" }} value="By" />
                </span>
                <FormROValue className="uiSpacerH5" formObject={formObject} rowKey="" action={{ paramName: "loggedBy" }} />
            </div>
            <FormWrapper customWrapper="div" formObject={formObject} rowKey="" 
                className="uiSpacer10" action={{ paramName: "status" }} >
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "status" }} value="Status" />
                </span>
                <FormInput formObject={formObject} rowKey="" className=""
                        action={{ InputType: "ac", paramName: "status", acMethod: "CategoryDetail", acDepCtrl: { dparam: "%dataList.valLCat" } }}
                    />
                <FormSH formObject={formObject} rowKey=""
                    action={{ actionId: "new", paramName: "status",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                     >
                </FormSH>
            </FormWrapper>
            <FormWrapper customWrapper="div" formObject={formObject} rowKey="" 
                className="uiSpacer10" action={{ paramName: "title" }} >
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "title" }} value="Title" />
                </span>
                <FormInput formObject={formObject} rowKey="" autofocus className="uiInput"
                    action={{ InputType: "input", paramName: "title" }}
                />
            </FormWrapper>
            <div className="uiSpacer10">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "message" }} value="Message" />
                </span>
                <FormRichText formObject={formObject} rowKey="" rows="5" cols="82" className="uiFrmText"
                    action={{ paramName: "message" }}
                />
            </div>
            <div className="uiSpacer10">
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "timeSpent" }} value="Time Spent" />
                </span>
                <FormHHMMInput formObject={formObject} rowKey="" className="uiTimeInput" 
                            action={{ InputType: "input", paramName: "timeSpent", actionParam: {} }} />
            </div>
        </FormDialog>
    )
}

export default withView(DocLogEditor, "taskLog", "taskLog,taskHeader,taskDetail")